import { useMutation } from "react-query";
import servicesUtils from "../../../utils/servicesUtils";

const useAddFilter = () => {
  return useMutation((params) =>
    servicesUtils.postService("/profile/filters/create/", params)
  );
};

export default useAddFilter;
